import React from "react";
import styled from "styled-components";
import Item from "./item";
import Header from "./../header/header";
import Item1 from "./../../images/optimised/spray-decorating.jpg";
import Item2 from "./../../images/optimised/cladding-spraying.jpg";
import Item3 from "./../../images/optimised/ceiling-spraying.jpg";
import Item4 from "./../../images/optimised/shop-front-spraying.jpg";
import Item5 from "./../../images/optimised/roller-shutter-spraying.jpg";
import Item6 from "./../../images/optimised/intumescent-coatings.jpg";
import GalleryPic1 from "./../../images/gallery/ceilings-001.jpg";
import GalleryPic2 from "./../../images/gallery/ceilings-002.jpg";
import GalleryPic3 from "./../../images/gallery/ceilings-003.jpg";
import GalleryPic4 from "./../../images/gallery/intumescent-001.jpg";
import GalleryPic5 from "./../../images/gallery/shop-front-spraying-001.jpg";
import GalleryPic6 from "./../../images/gallery/curtain-wall-spraying-001.jpg";
import GalleryPic7 from "./../../images/gallery/roller-shutter-spraying-001.jpg";
import GalleryPic8 from "./../../images/gallery/spray-decorating-001.jpg";
import GalleryPic9 from "./../../images/gallery/cladding-spraying-001.jpg";
import GalleryPic10 from "./../../images/gallery/35617063_193083228212865_6782407771665989632_n.jpg";
import GalleryPic11 from "./../../images/gallery/36086428_2050425695032253_1159883955831308288_n.jpg";
import GalleryPic12 from "./../../images/gallery/36148668_480576865735071_4262593043703529472_n.jpg";
import GalleryPic1_thumbnail from "./../../images/gallery/thumbnails/ceilings-001-thumbnail.jpg";
import GalleryPic2_thumbnail from "./../../images/gallery/thumbnails/ceilings-002-thumbnail.jpg";
import GalleryPic3_thumbnail from "./../../images/gallery/thumbnails/ceilings-003-thumbnail.jpg";
import GalleryPic4_thumbnail from "./../../images/gallery/thumbnails/intumescent-001-thumbnail.jpg";
import GalleryPic5_thumbnail from "./../../images/gallery/thumbnails/shop-front-spraying-001-thumbnail.jpg";
import GalleryPic6_thumbnail from "./../../images/gallery/thumbnails/curtain-wall-spraying-001-thumbnail.jpg";
import GalleryPic7_thumbnail from "./../../images/gallery/thumbnails/roller-shutter-spraying-001-thumbnail.jpg";
import GalleryPic8_thumbnail from "./../../images/gallery/thumbnails/spray-decorating-001-thumbnail.jpg";
import GalleryPic9_thumbnail from "./../../images/gallery/thumbnails/cladding-spraying-001-thumbnail.jpg";
import GalleryPic10_thumbnail from "./../../images/gallery/thumbnails/35617063_193083228212865_6782407771665989632_n_thumbnail.jpg";
import GalleryPic11_thumbnail from "./../../images/gallery/thumbnails/36086428_2050425695032253_1159883955831308288_n_thumbnail.jpg";
import GalleryPic12_thumbnail from "./../../images/gallery/thumbnails/36148668_480576865735071_4262593043703529472_n_thumbnail.jpg";


import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from 'react-image-gallery';

const Container = styled.div`
   width: 90%;
   max-width: 1200px;
   margin: auto;
   @media (min-width: 768px) {
        width: 80%;
}
`;

const Services = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    align-content: flex-start;
    background: #fefefe;
    margin-top: 64px;
`;

const Title = styled.h2`
    font-weight: bold;
    font-size: 32px;
    margin-top: 64px;
    margin-bottom: 8px;
`;

const Paragraph = styled.p`
    font-weight: normal;
    font-size: 17px;
    margin: 0;
    margin-bottom: 32px;
`;

// https://facebook.github.io/react-360/docs/publish.html

const images = [
    {
        original: `${GalleryPic1}`,
        originalAlt: "Ceiling Spraying",
        originalTitle: "Ceiling Spraying",
        thumbnail: `${GalleryPic1_thumbnail}`,
        thumbnailAlt: "Ceiling Spraying",
        thumbnailTitle: "Ceiling Spraying",
    },
    {
        original: `${GalleryPic2}`,
        originalAlt: "Ceiling Spraying",
        originalTitle: "Ceiling Spraying",
        thumbnail: `${GalleryPic2_thumbnail}`,
        thumbnailAlt: "Ceiling Spraying",
        thumbnailTitle: "Ceiling Spraying",
    },
    {
        original: `${GalleryPic3}`,
        originalAlt: "Ceiling Spraying",
        originalTitle: "Ceiling Spraying",
        thumbnail: `${GalleryPic3_thumbnail}`,
        thumbnailAlt: "Ceiling Spraying",
        thumbnailTitle: "Ceiling Spraying",
    },
    {
        original: `${GalleryPic4}`,
        originalAlt: "Intumescent Coatings",
        originalTitle: "Intumescent Coatings",
        thumbnail: `${GalleryPic4_thumbnail}`,
        thumbnailAlt: "Intumescent Coatings",
        thumbnailTitle: "Intumescent Coatings",
    },
    {
        original: `${GalleryPic5}`,
        originalAlt: "Shop Front Spraying",
        originalTitle: "Shop Front Spraying",
        thumbnail: `${GalleryPic5_thumbnail}`,
        thumbnailAlt: "Shop Front Spraying",
        thumbnailTitle: "Shop Front Spraying",
    },
    {
        original: `${GalleryPic6}`,
        originalAlt: "Curtain Wall Spraying",
        originalTitle: "Curtain Wall Spraying",
        thumbnail: `${GalleryPic6_thumbnail}`,
        thumbnailAlt: "Curtain Wall Spraying",
        thumbnailTitle: "Curtain Wall Spraying",
    },
    {
        original: `${GalleryPic7}`,
        originalAlt: "Roller Shutter Spraying",
        originalTitle: "Roller Shutter Spraying",
        thumbnail: `${GalleryPic7_thumbnail}`,
        thumbnailAlt: "Roller Shutter Spraying",
        thumbnailTitle: "Roller Shutter Spraying",
    },
    {
        original: `${GalleryPic8}`,
        originalAlt: "Spray Decorating",
        originalTitle: "Spray Decorating",
        thumbnail: `${GalleryPic8_thumbnail}`,
        thumbnailAlt: "Spray Decorating",
        thumbnailTitle: "Spray Decorating",
    },
    {
        original: `${GalleryPic9}`,
        originalAlt: "Cladding Spraying",
        originalTitle: "Cladding Spraying",
        thumbnail: `${GalleryPic9_thumbnail}`,
        thumbnailAlt: "Cladding Spraying",
        thumbnailTitle: "Cladding Spraying",
    },
    {
        original: `${GalleryPic10}`,
        originalAlt: "test",
        originalTitle: "test",
        thumbnail: `${GalleryPic10_thumbnail}`,
        thumbnailAlt: "test",
        thumbnailTitle: "test",
    },
    {
        original: `${GalleryPic11}`,
        originalAlt: "test",
        originalTitle: "test",
        thumbnail: `${GalleryPic11_thumbnail}`,
        thumbnailAlt: "test",
        thumbnailTitle: "test",
    },
    {
        original: `${GalleryPic12}`,
        originalAlt: "test",
        originalTitle: "test",
        thumbnail: `${GalleryPic12_thumbnail}`,
        thumbnailAlt: "test",
        thumbnailTitle: "test",
    },
  ]

const Grid = ({Heading}) => (
<Container >
    <Header></Header>
    <Title>Domestic, Commercial &amp; Industrial Projects, Nationwide.</Title>
    <Paragraph>Our dedicated team of painters and decorators have extensive experience working on domestic, commercial and industrial projects.<br />
From redecorating shopfronts to prepping and painting skirting boards, and spraying fire retardant paint in industrial warehouses; we can do it all.<br /><br />

No matter how big or small your project may be, we’d love to help. Find out more about the services we offer below, or get in touch with us today.</Paragraph>
    <Services>
        <Item Image={Item1} alt="Spray Decorating" title="Spray Decorating" Heading="Spray Decorating" href="spray-decorating" />
        <Item Image={Item2} alt="Cladding Spraying" title="Cladding Spraying" Heading="Cladding Spraying" href="cladding-spraying" />
        <Item Image={Item3} alt="Ceiling Spraying" title="Ceiling Spraying" Heading="Ceiling Spraying" href="ceiling-spraying" />
        <Item Image={Item4} alt="Shop Front Spraying" title="Shop Front Spraying" Heading="Shop Front Spraying" href="shop-front-spraying" />
        <Item Image={Item5} alt="Roller Shutter Spraying" title="Roller Shutter Spraying" Heading="Roller Shutter Spraying" href="roller-shutter-spraying" />
        <Item Image={Item6} alt="Intumescent Coatings" title="Intumescent Coatings" Heading="Intumescent Coatings" href="intumescent-coatings" />
    </Services>
    <Title>Why Choose Advanced Spray Decorators?</Title>
    <Paragraph>
    For over ten years, we’ve been travelling across the country working on several extremely exciting painting and decorating projects.<br />
Our staff are dedicated and knowledgeable, and love helping to turn our customers’ design visions into reality.<br />
Are you looking for an experienced team of painters and decorators to help you out on a project? Get in touch today! We can help to answer any questions you may have, and we’ll provide you with a free quote.
    </Paragraph>
    <Title>Gallery</Title>
    <Paragraph>A gallery of our work</Paragraph>
    <ImageGallery items={images} />
</Container>
);

export default Grid;


// WEBPACK FOOTER //
// ./src/components/grid/grid.js